import type { MetricsFilters } from "@/lib/filters";
import {
  type DrilldownData,
  useWebsitePageMetricDrilldown,
  type WebsitePageMetrics,
} from "./use-website-page-metrics";

// Re-export all drilldown types
export type {
  AccountEngagedDrilldown,
  DealContactEngagedDrilldown,
  OpportunityActivatedDrilldown,
  OpportunityInfluencedDrilldown,
  PageViewDrilldown as WebsiteMetricDrilldownRecord,
  PersonEngagedDrilldown,
} from "./use-website-page-metrics";

export interface WebsiteMetricDrilldownResponse {
  url: string;
  metric: string;
  results: DrilldownData;
  count: number;
  limit: number;
  offset: number;
}

// Wrapper function for backward compatibility
export function useWebsiteMetricDrilldown({
  url,
  metric,
  channelId = "all",
  startDate,
  endDate,
  filters,
  limit = 100,
  offset = 0,
  enabled = true,
}: {
  url: string;
  metric: keyof WebsitePageMetrics;
  channelId?: string;
  startDate?: string;
  endDate?: string;
  filters?: MetricsFilters;
  limit?: number;
  offset?: number;
  enabled?: boolean;
}) {
  // Use the new hook
  const result = useWebsitePageMetricDrilldown({
    url: url || null,
    metric,
    channelFilter: channelId,
    startDate,
    endDate,
    filters,
    limit,
    offset,
    enabled,
  });

  // The new hook already returns the correct structure, just pass it through
  return result;
}
